<template>
  <div>
    <t-tabs :items="tabNavItems" class="tw-mt-5" />
    <div class="tw-mb-2 tw-bg-white tw-p-2">
      <router-view />
    </div>
    <actions-buttons
      :message_id="messageId"
      :tier_id="selectedUser.id"
      :tier="tierType"
      :selected="messageDetails"
    ></actions-buttons>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { TIER } from "@/constants";
import ActionsButtons from "@/views/Common/MessageOverview/ActionsButtons/index.vue";
import TTabs from "@/components/TTabs";

export default {
  name: "MessageOverviewWrap",
  components: {
    ActionsButtons,
    TTabs,
  },
  data() {
    return {
      tabNavItems: [],
      tierType: TIER.users,
      messageId: this.$route.params.id,
    };
  },
  computed: {
    ...mapGetters("message", ["messageDetails"]),
    ...mapGetters("authentication", ["selectedUser"]),
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  mounted() {
    this.setPageTitle(`Message ID: ${this.messageId}`);
    this.setPageSubtitle([]);
    this.tabNavItems = this.$secondaryNav.userQuarantineMessageOverview(
      this.messageId
    );
  },
};
</script>
